import React from 'react';
import FormDefault from '~/components/FormDefault';
import Search from '~/components/Search';
import { Container, ButtonForm } from './styles';
import { useClassificacaoIbsCbs } from './hooks/useClassificacaoIbsCbs';
import DefaultLoader from '~/components/DefaultLoader';
import { FormIBS } from './components/formIBS';
import { FormCBS } from './components/formCBS';
import { FormClassificacao } from './components/formClassificacao';
import Tippy from '@tippyjs/react';
import { FaCheck } from 'react-icons/fa';

export const ClassificacaoIbsCbsContent: React.FC = () => {
  const {
    formClassificao: { watch },
    isUpdate,
    showSearch,
    setShowSearch,
    onNew,
    resetFormData,
    onSave,
    onRowClick,
    handleInativar,
    loading,
    flgInativo,
    handleAtivar,
  } = useClassificacaoIbsCbs();

  // Botão Customizável para Ativar Cliente
  const ButtonAtivar = () => {
    return (
      <Tippy placement="bottom" content="Ativar" arrow animation="scale">
        <ButtonForm onClick={handleAtivar}>
          <FaCheck /> Ativar
        </ButtonForm>
      </Tippy>
    );
  };

  if (loading) {
    return <DefaultLoader />;
  }
  return (
    <Container>
      {showSearch && (
        <Search newData={onNew} onRowClick={onRowClick} codTela={317} />
      )}
      {!showSearch && (
        <FormDefault
          codTela={317}
          title="Classificação IBS/CBS"
          codigoRegistro={[
            {
              value: watch('cod_ibs_cbs'),
              des_campo: 'Código',
            },
          ]}
          onSave={async () => {
            await onSave();
          }}
          isUpdate={isUpdate}
          onCancel={() => setShowSearch(true)}
          onNew={onNew}
          onDelete={handleInativar}
          onClearFields={resetFormData}
          onReturnSearch={() => {
            setShowSearch(true);
            resetFormData();
          }}
          labelButtonTrash="Inativar"
          deleteMessage="Deseja realmente inativar o registro?"
          isDelete={!flgInativo}
          customButtonsUpdate={flgInativo && <ButtonAtivar />}
        >
          <FormClassificacao />
          <FormCBS />
          <FormIBS />
        </FormDefault>
      )}
    </Container>
  );
};
